module.exports = __webpack_public_path__ + "3c159f6ec61b38196332b3ab5b242f0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/navbar/overview_redisign.png
// module id = 474
// module chunks = 0